import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import * as jQuery from 'jquery';
import * as _ from 'underscore';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { CreativeAdSize, CreativePerformance, CreativeStats } from '../creative-detail-v2/creative-detail.interface';

@Component({
	selector: 'app-creative-r10',
	styleUrls: ['./creative-r10.component.css'],
	templateUrl: './creative-r10.component.html',
	encapsulation: ViewEncapsulation.None
})
export class CreativeR10Component implements OnInit, OnDestroy {
	@Input() downloadconfig: string;
	@Input() sectionclass: string;
	@Input() legend: any;
	@Input() nodatamessage: string;
	@Input() externalwidgetsconfiguration: any;
	@Input() sectiontitle: string;
	@Input() uikitresponseconfig: any;
	@Input() customchartconfiguration: any;
	@Input() seriesviewconfiguration: any;
	@Input() datatableconfig: any;
	@Input() columnsconfig: any;
	@ViewChild('videoName') videoplayer: any;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrow: true,
		duration: 750,
		scale: 'big',
		dynamicTitle: true,
		theme: 'creatives'
	};
	public widgetDataSubscription;
	public reloadSubscription;
	public key: string;
	public colorPalette: ColorPalette;
	public selectedCreative: CreativePerformance;
	public widgetsConfiguration: any;
	public videoPlayerConfig: any;
	public audioPlayerConfig: any;
	public progressBarConfig;
	public creativeData: any;
	public currentCreativeDetails: any;
	public currentCreativeIndex: any;
	public showLoad = true;
	public hasData = true;
	public defaultColor: string = '#ffffff';
	public isVideo: boolean;
	public isAudio: boolean;
	public isSEM: boolean;
	public isSocial: boolean = false;
	public isDisplay: boolean = false;
	public isGam: boolean = false;
	public isGeofence: boolean = false;
	public isEmail: boolean = false;
	protected creativesDropdown: CreativePerformance[] = [];
	public noCreativeSizes = [];
	public isR10Config: boolean = false;

	public creativeImageData = {};
	public creativeConfiguration = {
		availableSizes: ['300x600', '160x600', '300x250', '336x280', '320x50', '728x90'],
		imageNames: {
			imageNames: {}
		},
		skeletonImages: {
			skeletonImages: {}
		},
		enableMissingCreative: true,
		creativeStyles: {},
		creativeResponseConfig: [
			{
				key: 'creativeImage',
				dataType: 'string'
			},
			{
				key: 'isNative',
				dataType: 'string'
			},
			{
				key: 'adSize',
				dataType: 'string'
			}
		]
	};

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.cdr.detectChanges();
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.widgetsConfiguration = JSON.parse(decodeURI(this.externalwidgetsconfiguration));
		this.videoPlayerConfig = this.widgetsConfiguration.videoPlayerConfig;
		this.audioPlayerConfig = this.widgetsConfiguration.audioPlayerConfig;
		this.progressBarConfig = this.widgetsConfiguration.progressBarConfig;
		this.isR10Config = this.analyticsDataModel.config.version.toLowerCase() === 'r10' ? true : false;
		this.legend = JSON.parse(decodeURI(this.legend));
		//filtering legend by permission
		this.legend = _.filter(this.legend, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});
		this.requestData();
	}

	ngAfterContentChecked(): void {
		this.noCreativeSizes.forEach((adsize) => {
			jQuery('.display-creatives-r10 .display-creative .fq-creative.creative-' + adsize + ' .adSize-title').css({
				color: '#d8d8d8'
			});
		});
	}
	requestData(): void {
		this.hasData = false;
		this.showLoad = true;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		if (
			this.analyticsDataModel.getCurrentPath() === PATHS.CTV ||
			this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL ||
			this.analyticsDataModel.getCurrentPath() === PATHS.GEOVIDEO ||
			this.analyticsDataModel.getCurrentPath() === PATHS.RADIO ||
			this.analyticsDataModel.getCurrentPath() === PATHS.Email
		) {
			this.isVideo = true;
			if (this.analyticsDataModel.getCurrentPath() === PATHS.RADIO) {
				this.isAudio = true;
				this.isVideo = false;
			} else if (this.analyticsDataModel.getCurrentPath() === PATHS.Email) {
				this.isEmail = true;
				this.isVideo = false;
			}

			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.key)
				.subscribe((res: any) => {
					this.showLoad = false;
					if (res.success && res.data.length > 0) {
						this.hasData = true;
						if (this.analyticsDataModel.getCurrentPath() === PATHS.GEOVIDEO) {
							this.setCreativeData(res.data);
						} else {
							this.setData(res.data);
						}
					} else {
						this.hasData = false;
						this.creativeData = [];
						this.creativesDropdown = [];
					}
				});
		} else if (
			this.analyticsDataModel.getCurrentPath() === PATHS.SEM ||
			this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL ||
			this.analyticsDataModel.getCurrentPath() === PATHS.DISPLAY ||
			this.analyticsDataModel.getCurrentPath() === PATHS.GAM ||
			this.analyticsDataModel.getCurrentPath() === PATHS.GEOFENCE
		) {
			this.isSocial = this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL;
			this.isDisplay = this.analyticsDataModel.getCurrentPath() === PATHS.DISPLAY;
			this.isGam = this.analyticsDataModel.getCurrentPath() === PATHS.GAM;
			this.isGeofence = this.analyticsDataModel.getCurrentPath() === PATHS.GEOFENCE;
			this.isSEM = this.analyticsDataModel.getCurrentPath() === PATHS.SEM;

			if (this.widgetDataSubscription) {
				this.widgetDataSubscription.unsubscribe();
			}
			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.key)
				.subscribe((res: any) => {
					this.showLoad = false;
					if (res.success && res.data.length > 0) {
						this.hasData = true;
						this.setCreativeData(res.data);
					} else {
						this.hasData = false;
						this.creativeData = [];
						this.creativesDropdown = [];
					}
				});
		}
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	getPreviewScreenshot(imageURL: string): void {
		const win = window.open(imageURL, '_blank');
		win.focus();
	}

	setData(response: object): void {
		this.currentCreativeIndex = 0;
		this.creativeData = response;
		if (this.isEmail) {
			this.creativeData.sort((a, b) => {
				const date1 = new Date(a.date);
				const date2 = new Date(b.date);
				return date1.getTime() - date2.getTime() != 0
					? date1.getTime() - date2.getTime()
					: b.clicks - a.clicks != 0
					? b.clicks - a.clicks
					: b.opens - a.opens;
			});
		}
		this.creativeData = this.isR10Config
			? _.sortBy(_.sortBy(this.creativeData, 'name').reverse(), (impression: any) => {
					return Number(impression.impressions);
			  }).reverse()
			: this.creativeData;
		this.setCreativeIndex(this.currentCreativeIndex);
	}

	setCreativeData(response: object[]): void {
		this.currentCreativeIndex = 0;
		this.creativesDropdown = [];
		this.creativeData = response;
		this.creativeData = _.sortBy(
			_.sortBy(_.sortBy(this.creativeData, 'creativeName'), (impression: any) => {
				return Number(impression.impressions);
			}),
			(click: any) => {
				return Number(click.clicks);
			}
		).reverse();
		this.creativeData = this.isR10Config
			? _.sortBy(_.sortBy(this.creativeData, 'name').reverse(), (impression: any) => {
					return Number(impression.impressions);
			  }).reverse()
			: this.creativeData;
		this.creativeData.forEach((obj, index) => {
			this.getDropdownListItem(index);
		});
		this.setCreativeIndex(this.currentCreativeIndex);
	}

	changeCreativeData(creative: object): void {
		const selectedIndex = this.creativeData.findIndex((creativeObj) => {
			return creativeObj.cup_version_id === creative['cup_version_id'];
		});
		this.setCreativeIndex(selectedIndex);
	}

	// 1 creative can have multiple blasts. So check based on adgroup id.
	changeEmailCreativeData(creative: object): void {
		const selectedIndex = this.creativeData.findIndex((creativeObj) => {
			return creativeObj.adgroup_id === creative['adgroup_id'];
		});
		this.setCreativeIndex(selectedIndex);
	}

	changeSemCreativeData(creative: object): void {
		this.creativesDropdown.forEach((creativeObj) => {
			if (creativeObj.creativeIndex === creative['creativeIndex']) {
				this.setCreativeIndex(creativeObj.creativeIndex);
			}
		});
	}

	isTypeString(description: any): boolean {
		return typeof description === 'string';
	}

	setCreativeIndex(currentCreativeIndex: number | string): void {
		let adSizes = [];
		if (this.creativeData[currentCreativeIndex] && this.creativeData[currentCreativeIndex].creatives_by_ads) {
			adSizes = this.mapResponseToAdSizes(this.creativeData[currentCreativeIndex].creatives_by_ads);
		}
		this.currentCreativeDetails = {
			absTopImpressionRate: UtilityService.isUndefinedOrNull(
				this.creativeData[currentCreativeIndex].abs_top_impression_share
			)
				? null
				: parseFloat(this.creativeData[currentCreativeIndex].abs_top_impression_share) === 0
				? null
				: parseFloat(this.creativeData[currentCreativeIndex].abs_top_impression_share),
			adHeadline: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].ad_headline)
				? ''
				: this.creativeData[currentCreativeIndex].ad_headline === ''
				? ' '
				: this.creativeData[currentCreativeIndex].ad_headline,
			adInteractionRate: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].interaction_rate)
				? 0
				: parseFloat(this.creativeData[currentCreativeIndex].interaction_rate),
			adInteractions: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].ad_interactions)
				? 0
				: parseFloat(this.creativeData[currentCreativeIndex].ad_interactions),
			audioURL: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].audio_url)
				? ''
				: this.creativeData[currentCreativeIndex].audio_url,
			avgPosition: parseFloat(this.creativeData[currentCreativeIndex].avg_position),
			callExtension:
				this.creativeData[currentCreativeIndex] && this.creativeData[currentCreativeIndex].call_extn
					? JSON.parse(this.creativeData[currentCreativeIndex].call_extn)[0][1]
					: '',
			calloutsExtn: this.getCalloutsExtn(this.currentCreativeIndex),
			clickRate: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].click_rate)
				? UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].clickthroughrate)
					? 0
					: parseFloat(this.creativeData[currentCreativeIndex].clickthroughrate)
				: parseFloat(this.creativeData[currentCreativeIndex].click_rate),
			click_rate: this.creativeData[currentCreativeIndex].click_rate
				? parseFloat(this.creativeData[currentCreativeIndex].click_rate)
				: null,
			clicks: this.creativeData[currentCreativeIndex].clicks
				? parseFloat(this.creativeData[currentCreativeIndex].clicks)
				: null,
			completion_rate: this.creativeData[currentCreativeIndex]['100_percent_rate']
				? parseFloat(this.creativeData[currentCreativeIndex]['100_percent_rate'])
				: null,
			completions: this.creativeData[currentCreativeIndex]['100_percent_value']
				? parseInt(this.creativeData[currentCreativeIndex]['100_percent_value'])
				: null,
			creativeIndex: this.currentCreativeIndex,
			creativeName: this.creativeData[currentCreativeIndex].creative_name
				? this.creativeData[currentCreativeIndex].creative_name
				: this.creativeData[currentCreativeIndex].ad_headline
				? this.creativeData[currentCreativeIndex].ad_headline
				: this.creativeData[currentCreativeIndex].name,
			description: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].description)
				? ''
				: this.creativeData[currentCreativeIndex].description,
			enablePreviewContent: false,
			exposures: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].exposures)
				? 0
				: parseFloat(this.creativeData[currentCreativeIndex].exposures),
			iframeUrl: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].iframe_url)
				? null
				: this.creativeData[currentCreativeIndex].iframe_url.replace(
						/width="([^"]+)"/g,
						'width="540px" height="600px" scrolling="no"'
				  ),
			creativeImageData: this.processCreativeImageData(
				adSizes,
				this.creativeData[currentCreativeIndex].isNative == '0' ? false : true
			),
			creativeConfiguration: this.creativeConfiguration,
			impressions: this.creativeData[currentCreativeIndex].impressions
				? parseFloat(this.creativeData[currentCreativeIndex].impressions)
				: null,
			isIAB: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].isIAB)
				? false
				: Number(this.creativeData[currentCreativeIndex].isIAB)
				? true
				: false,
			isNative: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].isNative)
				? false
				: Number(this.creativeData[currentCreativeIndex].isNative)
				? true
				: false,
			location: this.getLocation(this.currentCreativeIndex),
			mp4: this.creativeData[currentCreativeIndex].mp4 || this.creativeData[currentCreativeIndex].video_url,
			name: this.creativeData[currentCreativeIndex].name ? this.creativeData[currentCreativeIndex].name : null,
			native: this.creativeData[currentCreativeIndex].native,
			percent_rate_100: this.creativeData[currentCreativeIndex]['100_percent_rate']
				? parseFloat(this.creativeData[currentCreativeIndex]['100_percent_rate'])
				: null,
			percent_rate_25: this.creativeData[currentCreativeIndex]['25_percent_rate']
				? parseFloat(this.creativeData[currentCreativeIndex]['25_percent_rate'])
				: null,
			percent_rate_50: this.creativeData[currentCreativeIndex]['50_percent_rate']
				? parseFloat(this.creativeData[currentCreativeIndex]['50_percent_rate'])
				: null,
			percent_rate_75: this.creativeData[currentCreativeIndex]['75_percent_rate']
				? parseFloat(this.creativeData[currentCreativeIndex]['75_percent_rate'])
				: null,
			percent_value_100: this.creativeData[currentCreativeIndex]['100_percent_value']
				? parseFloat(this.creativeData[currentCreativeIndex]['100_percent_value'])
				: null,
			percent_value_25: this.creativeData[currentCreativeIndex]['25_percent_value']
				? parseFloat(this.creativeData[currentCreativeIndex]['25_percent_value'])
				: null,
			percent_value_50: this.creativeData[currentCreativeIndex]['50_percent_value']
				? parseFloat(this.creativeData[currentCreativeIndex]['50_percent_value'])
				: null,
			percent_value_75: this.creativeData[currentCreativeIndex]['75_percent_value']
				? parseFloat(this.creativeData[currentCreativeIndex]['75_percent_value'])
				: null,
			siteLinks: this.getSiteLinks(this.currentCreativeIndex),
			structuredSnippetExtn: this.getstructuredSnippetExtn(this.currentCreativeIndex),
			thumbnail: this.creativeData[currentCreativeIndex].thumbnail,
			topImpressionShare: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].top_impression_share)
				? null
				: parseFloat(this.creativeData[currentCreativeIndex].top_impression_share) === 0
				? null
				: parseFloat(this.creativeData[currentCreativeIndex].top_impression_share),
			url: this.getURL(this.currentCreativeIndex),
			versionId: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].cup_version_id)
				? 0
				: parseFloat(this.creativeData[currentCreativeIndex].cup_version_id),
			zones: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].zones)
				? 0
				: parseFloat(this.creativeData[currentCreativeIndex].zones),
			isIframeExpired: this.creativeData[currentCreativeIndex].is_iframe_expired == 0 ? false : true,
			snapshotPath: UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].snapshot_path)
				? null
				: this.creativeData[currentCreativeIndex].snapshot_path,
			isVideoCreative: this.creativeData[currentCreativeIndex].is_video_creative == 'video' ? true : false,
			chartdata: {
				days: this.creativeData[currentCreativeIndex]?.creatives_by_date,
				weeks: this.creativeData[currentCreativeIndex]?.creatives_by_week,
				months: this.creativeData[currentCreativeIndex]?.creatives_by_month
			},
			engagements: this.creativeData[currentCreativeIndex].engagements
				? this.creativeData[currentCreativeIndex].engagements
				: null,
			likes: this.creativeData[currentCreativeIndex].likes ? this.creativeData[currentCreativeIndex].likes : null,
			shares: this.creativeData[currentCreativeIndex].shares ? this.creativeData[currentCreativeIndex].shares : null,
			comments: this.creativeData[currentCreativeIndex].comments
				? this.creativeData[currentCreativeIndex].comments
				: null,
			reactions: this.creativeData[currentCreativeIndex].reactions
				? this.creativeData[currentCreativeIndex].reactions
				: null,
			saves: this.creativeData[currentCreativeIndex].saves ? this.creativeData[currentCreativeIndex].saves : null,
			youtube_verified_imprs_rate: this.creativeData[currentCreativeIndex].youtube_verified_imprs_rate
				? parseFloat(this.creativeData[currentCreativeIndex].youtube_verified_imprs_rate)
				: null,
			youtube_verified_imprs: this.creativeData[currentCreativeIndex].youtube_verified_imprs
				? parseFloat(this.creativeData[currentCreativeIndex].youtube_verified_imprs)
				: null,
			audience: this.creativeData[currentCreativeIndex].audience
				? parseFloat(this.creativeData[currentCreativeIndex].audience)
				: null,
			opens: this.creativeData[currentCreativeIndex].opens
				? parseFloat(this.creativeData[currentCreativeIndex].opens)
				: null,
			open_rate: this.creativeData[currentCreativeIndex].open_rate
				? parseFloat(this.creativeData[currentCreativeIndex].open_rate)
				: null,
			url_by_adgroup: this.creativeData[currentCreativeIndex].url_by_adgroup
				? this.creativeData[currentCreativeIndex].url_by_adgroup.sort((a, b) => b.url_clicks - a.url_clicks)
				: [],
			date: this.creativeData[currentCreativeIndex].date ? this.creativeData[currentCreativeIndex].date : null,
			from_line: this.creativeData[currentCreativeIndex].from_line
				? this.creativeData[currentCreativeIndex].from_line
				: null
		};
		//remove config for completion for chart
		if (this.isSocial && !this.currentCreativeDetails.isVideoCreative) {
			this.currentCreativeDetails.filter = ['completion'];
		}
		this.currentCreativeDetails = { ...this.currentCreativeDetails };
	}
	processCreativeImageData(adSizes: any, isNative: boolean) {
		let creativeImageDataObj = {};
		let adSizesArray = [];
		this.noCreativeSizes = [];
		let availableSizes = JSON.parse(JSON.stringify(this.creativeConfiguration.availableSizes));
		for (let i = 0; i < adSizes.length; i++) {
			let adSizeArrObj = {};
			adSizeArrObj['adSize'] = adSizes[i]['adSize'];
			adSizeArrObj['creativeImage'] = adSizes[i]['creativeThumbnail'];
			adSizesArray.push(adSizeArrObj);
		}
		for (let j = 0; j < availableSizes.length; j++) {
			let indexElement = adSizesArray
				.map((e) => {
					return e.adSize;
				})
				.indexOf(availableSizes[j]);
			if (indexElement == -1) {
				this.noCreativeSizes.push(availableSizes[j]);
				adSizesArray.push({
					adSize: availableSizes[j],
					creativeImage:
						'../../../../../assets/creative-assets/display_creatives/creative-' + availableSizes[j] + '.png'
				});
			}
		}
		creativeImageDataObj['images'] = adSizesArray;
		creativeImageDataObj['isNative'] = isNative;
		return creativeImageDataObj;
	}

	mapResponseToAdSizes(responseData: any): any {
		const creativeAdSizeArray = [];
		for (const response of responseData) {
			const adSizeObj: CreativeAdSize = {} as CreativeAdSize;
			adSizeObj.adSize = response.ad_size;
			adSizeObj.creativeThumbnail = UtilityService.checkEncodeURI(response.creative_image)
				? response.creative_image
				: encodeURI(response.creative_image);
			adSizeObj.cupVersionId = response.cup_version_id;
			creativeAdSizeArray.push(adSizeObj);
		}
		return creativeAdSizeArray;
	}
	getDropdownListItem(currentCreativeIndex: number | string): void {
		let processedObject: any;
		processedObject = {
			creativeIndex: currentCreativeIndex,
			creativeName: this.creativeData[currentCreativeIndex].creative_name
				? this.creativeData[currentCreativeIndex].creative_name
				: this.creativeData[currentCreativeIndex].ad_headline
				? this.creativeData[currentCreativeIndex].ad_headline
				: this.creativeData[currentCreativeIndex].name
		};
		this.creativesDropdown.push(processedObject);
	}

	getURL(currentCreativeIndex: number | string): string {
		let url = '';
		if (!UtilityService.isUndefinedOrNull(this.creativeData[currentCreativeIndex].url)) {
			try {
				url = JSON.parse(this.creativeData[currentCreativeIndex].url)[0];
			} catch (e) {
				url = this.creativeData[currentCreativeIndex].url;
			}
		}
		return url;
	}

	getSiteLinks(index: number): object[] {
		let siteLinks = [];
		const siteLinksArr = [];
		if (this.creativeData[index].sitelink_extn) {
			try {
				siteLinks = JSON.parse(this.creativeData[index].sitelink_extn);
			} catch (e) {
				siteLinks = [];
			}
			for (const item of siteLinks) {
				siteLinksArr.push({
					// tslint:disable-next-line:prefer-template
					description: (item['3'] || '') + ' ' + (item['4'] || ''),
					heading: item['1'],
					link: Array.isArray(item['5']) ? item['5'][0] : item['5']
				});
			}
		}
		return siteLinksArr;
	}

	getCalloutsExtn(index: number): object[] {
		const calloutsExtnArr = [];
		if (this.creativeData[index].callouts_extn) {
			const calloutsExtn = JSON.parse(this.creativeData[index].callouts_extn);
			for (const item of calloutsExtn) {
				calloutsExtnArr.push(item['1']);
			}
		}
		return calloutsExtnArr;
	}

	getstructuredSnippetExtn(index: number): object[] {
		const structuredSnippetExtnArr = [];
		if (this.creativeData[index].structuredsnippet_extn) {
			const structuredSnippetExtn = JSON.parse(this.creativeData[index].structuredsnippet_extn);
			for (const item of structuredSnippetExtn) {
				structuredSnippetExtnArr.push({
					type: item['1'],
					value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] !== '' ? item['2'].join(', ') : item['2']
				});
			}
		}
		return structuredSnippetExtnArr;
	}

	getLocation(index: number): string {
		const locationArr = [];
		if (this.creativeData[index].location_extn) {
			const locationObj = JSON.parse(this.creativeData[index].location_extn)[0];
			for (const prop in locationObj) {
				if (parseInt(prop, 10) > 1 && parseInt(prop, 10) < 8) {
					locationArr.push(locationObj[prop]);
				}
			}
			const location = locationArr.join(', ');
			return location;
		}
	}
	getCreativeSize(thumbnail: string): string {
		if (
			thumbnail.includes('728x90') ||
			thumbnail.includes('468x60') ||
			thumbnail.includes('320x50') ||
			thumbnail.includes('300x50')
		) {
			return '100% 30%';
		} else if (thumbnail.includes('300x600')) {
			return '75% 100%';
		} else if (thumbnail.includes('160x600')) {
			return '40% 100%';
		} else {
			return '100% 100%';
		}
	}
}
